<header data-bs-theme="dark">
  <nav class="navbar navbar-expand-xl navbar-dark bg-dark fixed-top shadow-sm">
    <div class="container-fluid justify-content-center">
      <a href="/" class="navbar-brand d-flex align-items-center me-md-auto text-brand">
        <strong>Taniti</strong>
      </a>

      <button class="navbar-toggler" type="button"
          data-bs-toggle="collapse" data-bs-target="#mainNavigation" aria-controls="mainNavigation"
          aria-expanded="false" aria-label="Toggle navigation"
          (click)="isMainNavCollapsed = !isMainNavCollapsed"> <span class="navbar-toggler-icon"></span>
      </button>

      <div [ngbCollapse]="isMainNavCollapsed" class="collapse navbar-collapse justify-content-end" id="mainNavigation">
        <app-main-navigation></app-main-navigation>
      </div>
    </div>
  </nav>
</header>
<main>
  <div class="content">

    <router-outlet />

  </div>
</main>
<footer class="container-fluid d-flex flex-column p-5 justify-content-center">
  <div class="row">
    <div class="col-md-4">
      <strong>Other Links</strong>
      <ul>
        <li><a href="#">The Official Tanitian Government Website</a></li>
      </ul>
    </div>
    <div class="col-md-4">
      <strong>Tanitian Travel Agencies</strong>
      <ul>
        <li><a href="#">Travel Agency 1</a></li>
        <li><a href="#">Travel Agency 2</a></li>
        <li><a href="#">Travel Agency 3</a></li>
      </ul>
    </div>
    <div class="col-md-4">
      <strong>Site Info</strong>
      <ul>
        <li><a href="#">Sitemap</a></li>
        <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Terms of Use Policy</a></li>
      </ul>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-md-6">Copyright &copy; 2025. Taniti Tourism Board.</div>
    <div class="col-md-6 text-end">All stock photos provided by <a href="https://unsplash.com/" target="_blank">Unsplash</a></div>
  </div>
</footer>
